module.exports = __webpack_public_path__ + "static/ebba-close-min-ddbee33e00641fed0a023bf2a384e4e4.jpg";